import { Component, OnInit, Inject, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { InjectionDataRecord } from '../_models/injection-data-record';
import { InjectionService } from '../_services/injection.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { WellDetailsModel } from '../_models/well-details-model';
import { NgDynamicBreadcrumbService } from 'ng-dynamic-breadcrumb';
import { UserWellsService } from '../user-wells.service';
import { MatDialog } from '@angular/material/dialog';
import { ApiResultErrorDialogComponent } from '../api-result-error-dialog/api-result-error-dialog.component';
import { InjectionFormationsEditorComponent } from '../injection-formations-editor/injection-formations-editor.component';

@Component({
  selector: 'app-injection-record-editor',
  templateUrl: './injection-record-editor.component.html',
  styleUrls: ['./injection-record-editor.component.css']
})
export class InjectionRecordEditorComponent implements OnInit, AfterViewInit, OnDestroy {

  injectionDetailsSubscription: Subscription;
  wellDetailsSubscription: Subscription;

  injectionDetails: InjectionDataRecord = new InjectionDataRecord();

  wellDetails: WellDetailsModel = null;

  mainFormGroup: FormGroup;
  injectionId: number;
  wellId: number;

  @ViewChild(InjectionFormationsEditorComponent) injectionFormationsForm: InjectionFormationsEditorComponent;

  constructor(
    private actRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private injectionService: InjectionService,
    public userWellsService: UserWellsService,
    protected router: Router,
    protected breadcrumbService: NgDynamicBreadcrumbService,
    protected dialog: MatDialog
  ) {

    this.injectionId = this.actRoute.snapshot.params.injectionId;
    this.wellId = this.actRoute.snapshot.params.wellId;

    this.refreshForm();
  }

  ngOnInit(): void {
    this.injectionService.GetInjectionDetailsForId(this.injectionId);
    this.userWellsService.LoadDetailsWell(this.wellId);
  }

  ngAfterViewInit() {
    this.injectionDetailsSubscription = this.injectionService.getInjectionDetailsForIdComplete.subscribe((result: InjectionDataRecord) => {
      this.injectionDetails = result;

      this.userWellsService.LoadDetailsWell(this.injectionDetails.WellId);

      var stringFormat = this.injectionService.getDateStringFormat(this.injectionDetails)
      var injDate = this.injectionDetails.InjectionDate;

      function formatDate(date, format) {
        const monthAbbreviations = [
          'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
          'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        ];
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;

        if (format == 'yyyy/MM/dd') {
          return [year, month, day].join('-');
        } else {
          return monthAbbreviations[parseInt(month) - 1] + ' ' + year;
        }
      }

      var breadcrumbdata = {
        InjectionDate: formatDate(injDate, stringFormat)
      };

      this.breadcrumbService.updateBreadcrumbLabels(breadcrumbdata);

      //this.refreshForm();
      this.mainFormGroup.patchValue(this.injectionDetails);
    },
    (err) => {
      //Handle an error where the injection details record didn't load for some reason.
    });

    //Subscribe to the well details service
    this.wellDetailsSubscription = this.userWellsService.detailsWell.subscribe((result: WellDetailsModel) => {
      this.wellDetails = result;

      var breadcrumbdata = {
        Uicnumber: this.wellDetails.Uicnumber.toString()
      };

      this.breadcrumbService.updateBreadcrumbLabels(breadcrumbdata);
    });
  }

  ngOnDestroy(): void {
    this.injectionDetailsSubscription.unsubscribe();
    this.wellDetailsSubscription.unsubscribe();
  }

  save() {

    var injModel = this.mainFormGroup.value;

    var formationFormValue = this.injectionFormationsForm.form.value;

    var formationIds = formationFormValue.FormationIds;

    injModel.FormationIds = formationIds;
    
    this.injectionService.UpdateRecord(injModel).then((result) => {

      if (result.Success) {

        var destinationUrl = "well/" + this.wellId;

        this.router.navigateByUrl(destinationUrl);
      }
      else {
        var dialogRef = this.dialog.open(ApiResultErrorDialogComponent, {
          data: result
        });
      }
    },
      (result) => {
        var dialogRef = this.dialog.open(ApiResultErrorDialogComponent, {
          data: result
        });
    });
  }

  refreshForm() {

    function otherDataValidator() {
      return (group: FormGroup): { [key: string]: any } => {
        var ret: any = {};

        //Make sure that the top and bottom of the injection interval are not reverse.
        if (group.controls.CurrentInjectionIntervalTop != null &&
          group.controls.CurrentInjectionIntervalBottom != null &&
          group.controls.CurrentInjectionIntervalTop.value != null &&
          group.controls.CurrentInjectionIntervalBottom.value != null &&
          group.controls.CurrentInjectionIntervalTop.value > group.controls.CurrentInjectionIntervalBottom.value) {
          ret.injectionIntervalReversed = true;
        }

        if (group.controls.CurrentInjectionIntervalTop != null &&
          group.controls.DepthTubingPacker != null &&
          group.controls.DepthTubingPacker.value > group.controls.CurrentInjectionIntervalTop.value) {
          ret.tubingPackerTooDeep = true;
        }

        var keys = Object.keys(group.controls);

        var sum = 0;
        var hasValues = false;

        for (var i = 0; i < keys.length; i++) {
          if (group.controls[keys[i]].value != null && keys[i].startsWith("Fraction")) {
            hasValues = true;
            sum += group.controls[keys[i]].value;
          }
        }

        if (hasValues && sum != 100) {
          ret.notEquals100 = true;
          ret.totalPercentages = sum;
        }

        if (group.controls.FractionOther.value != null &&
          group.controls.FractionOther.value != 0 &&
          (group.controls.OtherDesc.value == null ||
            group.controls.OtherDesc.value == "")) {
          ret.noOtherDesc = true;
        }


        return ret;
      }
    }

    function individualFractionValidator() {
      return (control: FormControl): {
        [key: string]: any
      } => {
        var ret: any = {
        };

        if (control.value != null && control.value > 100) {
          ret.greaterThan100 = true;
        }

        return ret;
      };
    }

    this.mainFormGroup = this.formBuilder.group(
      {
        'Id': [this.injectionDetails.Id, []],
        'WellId': [this.injectionDetails.WellId, []],
        'InjectionDate': [this.injectionDetails.InjectionDate, []],
        'InjectionEndDate': [this.injectionDetails.InjectionEndDate, []],
        'InjectionPressureAveragePsig': [this.injectionDetails.InjectionPressureAveragePsig, [Validators.required]],
        'InjectionPressureMaxPsig': [this.injectionDetails.InjectionPressureMaxPsig, [Validators.required]],
        'VolumeInjectedBbl': [this.injectionDetails.VolumeInjectedBbl, [Validators.required]],
        'TotalGasVolumeMcf': [this.injectionDetails.TotalGasVolumeMcf],
        'AnnulusPressureNumReadings': [this.injectionDetails.AnnulusPressureNumReadings, []],
        'AnnulusPressureMinPsig': [this.injectionDetails.AnnulusPressureMinPsig, []],
        'AnnulusPressureMaxPsig': [this.injectionDetails.AnnulusPressureMaxPsig, []],
        'CurrentInjectionIntervalTop': [this.injectionDetails.CurrentInjectionIntervalTop, []],
        'CurrentInjectionIntervalBottom': [this.injectionDetails.CurrentInjectionIntervalBottom, []],
        'Formation': [this.injectionDetails.Formation, []],
        'DepthTubingPacker': [this.injectionDetails.DepthTubingPacker, []],
        'InjectedFluidsOtherSources': [this.injectionDetails.InjectedFluidsOtherSources, []],
        'InjectionThrough': [this.injectionDetails.InjectionThrough, []],
        'FractionSaltWater': [this.injectionDetails.FractionSaltWater, individualFractionValidator()],
        'FractionFreshWater': [this.injectionDetails.FractionFreshWater, individualFractionValidator()],
        'FractionFractureWaterFlowBack': [this.injectionDetails.FractionFractureWaterFlowBack, individualFractionValidator()],
        'FractionNorm': [this.injectionDetails.FractionNorm, individualFractionValidator()],
        'FractionCo2': [this.injectionDetails.FractionCo2, individualFractionValidator()],
        'FractionNaturalGas': [this.injectionDetails.FractionNaturalGas, individualFractionValidator()],
        'FractionH2s': [this.injectionDetails.FractionH2s, individualFractionValidator()],
        'FractionPolymer': [this.injectionDetails.FractionPolymer, individualFractionValidator()],
        'FractionSteam': [this.injectionDetails.FractionSteam, individualFractionValidator()],
        'FractionAir': [this.injectionDetails.FractionAir, individualFractionValidator()],
        'FractionNitrogen': [this.injectionDetails.FractionNitrogen, individualFractionValidator()],
        'FractionOther': [this.injectionDetails.FractionOther, individualFractionValidator()],
        'OtherDesc': [this.injectionDetails.OtherDesc],
        'MaxDayInjLiqRate': [this.injectionDetails.MaxDayInjLiqRate],
        'MaxDayInjGasRate': [this.injectionDetails.MaxDayInjGasRate]
      }, {
      validator: otherDataValidator()
    });
  }
}
